import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function MemoryWall() {
  const gridRef = useRef();

  const memories = [
    { id: 1, title: 'Our First Meeting', description: 'Where it all began', emoji: '💫' },
    { id: 2, title: 'Our First Kiss', description: 'Time stood still', emoji: '💋' },
    { id: 3, title: 'Movie Night', description: 'Holding you close', emoji: '🎬' },
    { id: 4, title: 'Shopping Together', description: 'Making memories', emoji: '🛍️' },
    { id: 5, title: 'Korean BBQ', description: 'Delicious moments', emoji: '🍖' },
    { id: 6, title: 'Every Day', description: 'With you', emoji: '💖' }
  ];

  useEffect(() => {
    const cards = gridRef.current.querySelectorAll('.memory-card');
    
    gsap.fromTo(
      cards,
      { opacity: 0, y: 100 },
      {
        opacity: 1,
        y: 0,
        duration: 0.8,
        stagger: 0.15,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: gridRef.current,
          start: 'top 70%',
          end: 'top 30%',
          toggleActions: 'play none none reverse'
        }
      }
    );
  }, []);

  return (
    <section className="memory-wall">
      <div className="memory-header">
        <h2>Our Journey Together</h2>
        <p style={{ fontSize: '1.2rem', opacity: 0.7 }}>
          Every moment with you is a treasure I hold dear
        </p>
      </div>

      <div ref={gridRef} className="memory-grid">
        {memories.map((memory) => (
          <div key={memory.id} className="memory-card">
            <div className="memory-image">
              <span>{memory.emoji}</span>
            </div>
            <div className="memory-info">
              <h3>{memory.title}</h3>
              <p>{memory.description}</p>
            </div>
          </div>
        ))}
      </div>

      <p style={{ 
        textAlign: 'center', 
        marginTop: '4rem', 
        opacity: 0.6,
        fontSize: '1rem'
      }}>
        I Will <code>ALWAYS</code> Love you Baby ❤️
      </p>
    </section>
  );
}

export default MemoryWall;